import { Component, Input, OnInit } from "@angular/core";
import { EdpModalService } from "@edp-components/edp-modal";
import { IModalData } from "@edp-components/edp-modal/edp-modal.models";
import { ListItem } from "@edp-models/lists.model";
import { TranslateService } from "@ngx-translate/core";

@Component({
    selector: "modal-filter-picker",
    templateUrl: "./modal-filter-picker.component.html",
    styleUrls: ["./modal-filter-picker.component.scss"],
})
export class ModalFilterPickerComponent implements OnInit {
    @Input() public data: IModalData;
    title: string;
    filterList: ListItem[];
    selectedFilter: ListItem;

    constructor(private readonly edpModalService: EdpModalService, private translate: TranslateService) {}

    ngOnInit(): void {
        if (this.data.collection.title) {
            this.title = this.data.collection.title;
        }
        if (this.data.collection.filterList) {
            this.filterList = this.data.collection.filterList;
        }
        if (this.data.collection.selectedFilter) {
            this.selectedFilter = this.data.collection.selectedFilter;
        }
    }

    public selectFilter(selectedFilter: any): void {
        this.selectedFilter = selectedFilter;
        this.edpModalService.close({ selectedFilter });
    }

    public dismissModal(action: boolean): void {
        this.edpModalService.dismiss(action);
    }

}
